import React from "react";
import { NewPos } from "../../components/pos/newPos";

const CreateNewPos = () => {
  return <NewPos />;
};

export default CreateNewPos;
